export const networkUserStatuses = Object.freeze({
  ACTIVE: 'Active',
  PAUSED: 'Paused',
  PENDING: 'Pending',
  SUSPENDED: 'Suspended',
});
